module.exports = __webpack_public_path__ + "static/media/free-as-you-go-bg.b17fc330.png";